import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import Dialog from 'yoda-core-components/lib/components/Dialog';
import * as styles from './EcoRebates.css';

const EcoRebates = ({ skuId = '' }) => {
    const { isMobile } = useSelector(({ context: { deviceType = {} } = {} }) => deviceType);
    const [showDialog, setShowDialog] = useState(false);

    const handleOnClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(true);
    };

    return (
        skuId && (
            <button
                className={[
                    'cursor-pointer',
                    'font-open-sans',
                    'py-half',
                    'text-gray-600 text-small',
                    'underline',
                ].join(' ')}
                data-automation-id="product-eco-rebate"
                onClick={handleOnClick}
                type="button"
            >
                Rebates Available
                <Dialog
                    aria-label="EcoRebates &copy;"
                    body={
                        <iframe
                            className="h-full w-full"
                            src={`https://jcpenney.ecorebates.com/ui/widgets/jcpenney/rebatedetails.html?ecr_skus=${skuId}&ecr_uiContext=PLP`}
                            style={{
                                maxWidth: isMobile ? null : '816px',
                                minHeight: '600px',
                                minWidth: '325px',
                            }}
                            title="EcoRebates &copy;"
                        >
                            Content is not supported on this device
                        </iframe>
                    }
                    className={
                        isMobile
                            ? `${styles.dialog} ${styles.mobile} px-2 py-7`
                            : `${styles.dialog}`
                    }
                    onDismiss={() => setShowDialog(false)}
                    show={showDialog}
                />
            </button>
        )
    );
};

EcoRebates.propTypes = {
    skuId: string.isRequired,
};

export default EcoRebates;
